import { Injectable } from '@angular/core';

const enum NumericalRule {
	/** not numerical. */
	NO, 
	/** numerical */
	NUM_STD, 
	/** numerical signed. */
	NUM_SIGNED
}

@Injectable()
export class NumericalService {
	/* FIELDS ============================================================== */

	/**
	 * Compute the size value for a numeric field according the given edit code
	 * 
	 * @param numerical the type of numerical
	 * @return true if the field is a numerical
	 */
	static isNumerical(numerical : string) : boolean {
		return "NUM_STD" === numerical || "NUM_SIGNED" === numerical;
	}

	/**
	 * Check if a value is numeric or not
	 * 
	 * @param numerical the type of numerical
	 * @return true if the field is a numerical
	 */
	static isNumericValue(value : string) : boolean {
		return /^[ +-.,\d]+$/.test(value);
	}

	/**
	 * Convert Decimal format of numerical value depending on config QDECFMT
	 * Replace comma with point and point with comma
	 * 
	 * @param data the value to format
	 * @returns the formatted value
	 */
	static convertDecimalFormat(value : string, qdecfmt : string) : string {
		// Ensure the type is really a string
		if(typeof value !== "string"){
			return value;
		}
	
		if(qdecfmt == "J" || qdecfmt == "I") {
			let result = "";
			for (var ch of value) {
				if (ch == ','){
					result += '.';
				} else if (ch == '.'){
					result += ',';
				} else {
					result += ch;
				}
			}
			return result;
		} else {
			return value;
		}
	}
}
